
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'ChevronUpSolid' })
export default class ChevronUpSolid extends Vue {}
